import { render } from "./RowRadioButton.vue?vue&type=template&id=59ace01b"
import script from "./RowRadioButton.vue?vue&type=script&lang=js"
export * from "./RowRadioButton.vue?vue&type=script&lang=js"
script.render = render

export default script